
import { useLocation, useNavigate, useOutletContext, useParams, useSearchParams } from 'react-router-dom';
import Table from '../../ui/Table';
import Tag from '../../ui/Tag';
import { ValidationOverviewData } from '../../constants/validationOverviewData';
import Heading from '../../ui/Heading';
import SortIcon from '../../assets/icons/SortIcon';
import {
    getBounty,
    getBountySubmissions,
    getBountySubmissionsCount,
    getUnvalidatedBounties,
    getUnvalidatedBountiesCount,
    getValidationPreview,
} from '../../apis/bounties/bounties';
import { useEffect, useState } from 'react';
import WhiteCard from '../../ui/WhiteCard';
import StatsCard from '../../ui/StatsCard';
import IssuedIcon from '../../assets/icons/IssuedIcon';
import NotIssuedIcon from '../../assets/icons/NotIssuedIcon';

import Legend from '../../ui/Legend';
import ButtonNew from '../../ui/ButtonNew';
import { maxDate } from '../../helpers/maxDate';
import NoDataAvailable from '../../ui/NoDataAvailable';
import Loader from '../../ui/Loader';
import { FirstRank, SecondRank, ThirdRank } from '../../assets/icons/RankIcons';
import useLocalStorage from '../../hooks/useLocalStoarge';
import { formatIntDateAndThenTime } from '../../helpers/formatInDateAndThenTime';
import Pagination from '../../ui/Pagination';
import { requestFundTransfer } from '../../apis/validator/validating';
import AvatarImage from '../../ui/AvatarImage';
import { toast } from 'sonner';
import ForcefullyExpireBountyModal from '../bounties/ForcefullyExpireBounty';

// Component for ranks 4 and above
const HigherRank = ({ rank }) => (
    <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 19.2618L17.8198 22.7914C18.8856 23.4383 20.1898 22.4821 19.9094 21.2727L18.3667 14.6353L23.5134 10.1635C24.453 9.3479 23.9482 7.80105 22.7141 7.70261L15.9407 7.12606L13.2902 0.854283C12.8134 -0.284761 11.1866 -0.284761 10.7098 0.854283L8.05935 7.112L1.28591 7.68855C0.0518278 7.78699 -0.453025 9.33384 0.486562 10.1494L5.63325 14.6213L4.09065 21.2586C3.81017 22.468 5.11437 23.4242 6.18017 22.7774L12 19.2618Z"
            fill="#E08F66"
        />
        <text
            x="12"
            y="14"
            textAnchor="middle"
            dominantBaseline="middle"
            fill="white"
            fontSize="10"
            fontWeight="bold"
            fontFamily="Arial, sans-serif"
        >
            {rank}
        </text>
    </svg>
);

const rank = {
    1: <FirstRank />,
    2: <SecondRank />,
    3: <ThirdRank />,


};

function ValidationBountySubmission() {
    const { bountyId, id } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const [bountyDetails, setBountyDetails] = useState({});
    const [isVisible, setIsVisible] = useState(false);
    const [isModalOpen, setModalOpen] = useState(false); // Modal visibility state
    const [modalAction, setModalAction] = useState(''); // Track action type: 'duplicate' or 'delete'
    const [selectedBounty, setSelectedBounty] = useState(null); // Track selected bounty for modal
    const [requestingTransfer, setRequestingTransfer] = useState(false);
    const location = useLocation();
    const handleMouseEnter = () => {
        setIsVisible(true);
    };
    const handleMouseLeave = () => {
        setIsVisible(false);
    };
    const [isLoading, setIsLoading] = useState(true);
    const [submissions, setSubmissions] = useState([]);
    const [validationPreview, setValidationPreview] = useState({});
    const navigate = useNavigate();

    const [currentPage, setCurrentPage] = useState(1);
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [totalEntries, setTotalEntries] = useState(0);

    useEffect(
        function () {
            const fetchData = async () => {
                try {
                    setIsLoading(true);
                    const countData = await getBountySubmissionsCount(bountyId);
                    setTotalEntries(countData?.entryCount || 0);

                    const fromTab = searchParams.get('fromTab');
                    const queryParams = {};
                    if (fromTab === 'projects') {
                        queryParams.includeProjectBounties = true;
                        queryParams.includeIndividualBounties = true;
                    } else if (fromTab === 'events') {
                        queryParams.includeEventBounties = true;
                    }

                    const bountiesCountData = await getUnvalidatedBountiesCount(id, queryParams);
                    const totalBountiesCount = bountiesCountData?.entryCount || 0;

                    const [response1, response2, response3] = await Promise.all([
                        getBountySubmissions(bountyId, currentPage, entriesPerPage),
                        getUnvalidatedBounties(id, 1, totalBountiesCount, queryParams),
                        getValidationPreview(bountyId),
                    ]);

                    const extractedBounty = response2.find((bounty) => bounty._id === bountyId);

                    console.log(extractedBounty, response2, bountyId, 'see thi sis');

                    setIsLoading(false);
                    setSubmissions(response1);
                    setValidationPreview(response3);

                    setBountyDetails({ ...extractedBounty });
                } catch (error) {
                    console.log(error);
                }
            };
            fetchData();
        },
        [bountyId, id, currentPage, entriesPerPage, searchParams]
    );

    const entriesHandler = (val) => {
        setEntriesPerPage(val);
        setCurrentPage(1);
    };


    const { status } = bountyDetails;
    const currentTotal = bountyDetails?.totalSubmissionCount;
    const scoresCount = bountyDetails?.validatedSubmissionCount;
    const shouldDisable =
        currentTotal !== scoresCount || currentTotal === 0 || status?.toLowerCase() !== 'unvalidated';

    const hasRewardTie = (() => {
        if (!validationPreview?.rewardDistribution || !submissions.length) return false;

        const rewardedSubmissions = validationPreview.rewardDistribution
            .map((reward) => submissions.find((s) => s.submissionId === reward.submissionId))
            .filter((s) => s && s.accuracy >= 0);

        if (rewardedSubmissions.length === 0) return false;

        const scores = rewardedSubmissions.map((s) => s.accuracy);
        const uniqueScores = new Set(scores);

        // Check for ties within the rewarded group
        if (scores.length !== uniqueScores.size) return true;

        // Check for ties with non-rewarded submissions
        const minRewardedScore = Math.min(...scores);
        const rewardedIds = new Set(rewardedSubmissions.map((s) => s.submissionId));

        const hasTieWithNonRewarded = submissions.some(
            (s) => !rewardedIds.has(s.submissionId) && s.accuracy === minRewardedScore
        );

        return hasTieWithNonRewarded;
    })();

    const isButtonDisabled = shouldDisable || hasRewardTie;

    const onRequestingFundTransfer = async () => {
        try {
            setRequestingTransfer(true);
            const response = await requestFundTransfer(bountyId);

            if (response?.success) {
                // navigate(-1);
                setBountyDetails((prev) => {
                    return { ...prev, status: 'validation requested' };
                });
                toast.success('Fund transfer request has been initiated successfully.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setRequestingTransfer(false);
        }
    };

    const handleOpenModal = (action, bounty) => {
        setModalAction(action); // Set the action type ('duplicate' or 'delete')
        setSelectedBounty(bounty); // Set the selected bounty
        setModalOpen(true); // Open the modal
    };

    const handleCloseModal = () => {
        setModalOpen(false); // Close the modal
        setModalAction(''); // Clear action type
        setSelectedBounty(null); // Clear selected bounty
    };

    const handleConfirmAction = (newBounty, newStatus) => {
        if (modalAction === 'expire') {
            setBountyDetails((prev) => ({ ...prev, status: newStatus }));
        }
        handleCloseModal();
    };

    // Function to get rank for a submission if it's getting rewarded or has a tied score with a rewarded submission
    const getSubmissionRank = (submissionId) => {
        if (!validationPreview?.rewardDistribution) return null;

        // Find the current submission's score
        const currentSubmission = submissions.find((s) => s.submissionId === submissionId);
        if (!currentSubmission || currentSubmission.accuracy < 0) return null;

        const rewardedSubmissions = validationPreview.rewardDistribution
            .map((reward) => submissions.find((s) => s.submissionId === reward.submissionId))
            .filter((s) => s && s.accuracy >= 0);

        if (rewardedSubmissions.length === 0) return null;

        // Check if this is equal reward distribution by looking at reward amounts
        const rewardAmounts = validationPreview.rewardDistribution.map((r) => r.amount);
        const isEqualDistribution = rewardAmounts.every((amount) => amount === rewardAmounts[0]);

        if (isEqualDistribution) {
            // For equal distribution, check if all rewarded submissions have the same score
            const allScoresEqual = rewardedSubmissions.every((s) => s.accuracy === rewardedSubmissions[0].accuracy);

            if (allScoresEqual) {
                // If the current submission's score matches the rewarded score, give it rank 1
                if (currentSubmission.accuracy === rewardedSubmissions[0].accuracy) {
                    return rank[1];
                }
            }
        }

        // For rank-based distribution or unequal scores, use score-based ranking
        const rewardedSubmissionsSorted = rewardedSubmissions.sort((a, b) => b.accuracy - a.accuracy);

        // Find the rank based on score (handle ties)
        let rankPosition = 1;
        let currentScore = rewardedSubmissionsSorted[0]?.accuracy;

        for (let i = 0; i < rewardedSubmissionsSorted.length; i++) {
            if (rewardedSubmissionsSorted[i].accuracy < currentScore) {
                rankPosition = i + 1;
                currentScore = rewardedSubmissionsSorted[i].accuracy;
            }

            // Check if current submission has the same score as this ranked position
            if (rewardedSubmissionsSorted[i].accuracy === currentSubmission.accuracy) {
                if (rankPosition <= 3) {
                    return rank[rankPosition];
                } else {
                    return <HigherRank rank={rankPosition} />;
                }
            }
        }

        return null;
    };


    const fromTab = searchParams.get('fromTab');
    const fromPage = searchParams.get('from');

    console.log(location, bountyDetails, 'see the location to individual submission');

    return (
        <div>
            <div className="my-6">
                <p>Bounty Title :</p>

                <Heading type={'large'} className={'text-textPrimary font-medium '}>
                    {bountyDetails?.title}
                </Heading>
            </div>
            <div className="flex justify-between  ">
                <WhiteCard verticalMargin="" className="w-fit p-6 ">
                    <p className="font-semibold mb-2">Submissions</p>
                    <div className="flex items-center gap-4 ">
                        <StatsCard countHeading={'Current Total'} count={currentTotal ? currentTotal : 0} />
                        <StatsCard countHeading={'Not Scored'} count={currentTotal ? currentTotal - scoresCount : 0} />
                        <StatsCard countHeading={'Scored'} count={scoresCount ? scoresCount : 0} />
                    </div>
                </WhiteCard>

                {!isLoading &&
                    status?.toLowerCase() !== 'completed' &&
                    status?.toLowerCase() !== 'validation requested' &&
                    bountyDetails?.validationType !== 'AFTER_EACH_SUBMISSION' &&
                    !bountyDetails?.raisedFunding && (
                        <div className=" self-end">
                            <p className="mb-2">Propose Validation</p>
                            <div className="relative">
                                <div
                                    onMouseEnter={handleMouseEnter}
                                    onMouseLeave={handleMouseLeave}
                                    className="inline-block"
                                >
                                    <ButtonNew
                                        data-tooltip-target="tooltip-left"
                                        data-tooltip-placement="left"
                                        disabled={isButtonDisabled}
                                        type="button"
                                        onClick={() => {
                                            if (isButtonDisabled) return;
                                            navigate(`request`);
                                        }}
                                        variant="blue"
                                        size="md"
                                        shape="rounded"
                                    >
                                        Finalise Grading
                                    </ButtonNew>
                                </div>
                                <div
                                    id="tooltip-left"
                                    role="tooltip"
                                    style={{
                                        top: '50%',
                                        right: '100%',
                                        transform: 'translateY(-50%)',
                                    }}
                                    className={`absolute z-10 mr-3 w-[494px] px-4 py-2 transition-opacity duration-300 ${isVisible && isButtonDisabled ? 'opacity-100 visible' : 'opacity-0 invisible'
                                        } text-sm font-medium text-textPrimary border border-borderUnderline bg-grayBgNormal rounded-[4px] shadow-sm opacity-0`}
                                >
                                    <p className="text-sm">
                                        {hasRewardTie ? (
                                            'There is a tie between some of the submissions. To enable rank based rewards kindly revalidate the submissions.'
                                        ) : (
                                            <>
                                                Validation can be requested only after the bounty expires on &nbsp;
                                                {formatIntDateAndThenTime(bountyDetails?.expirationTimestamp)} and when
                                                all submissions have been validated.
                                            </>
                                        )}
                                    </p>
                                    <div class="tooltip-arrow" data-popper-arrow></div>
                                </div>
                            </div>
                        </div>
                    )}
                {!isLoading && status?.toLowerCase() !== 'completed' &&
                    status?.toLowerCase() !== 'validation requested' &&
                    bountyDetails?.validationType !== 'AFTER_EACH_SUBMISSION' &&
                    bountyDetails?.raisedFunding && (
                        <div className="self-end">
                            <div className="relative">
                                <ButtonNew
                                    onMouseEnter={handleMouseEnter}
                                    onMouseLeave={handleMouseLeave}
                                    data-tooltip-target="tooltip-left"
                                    data-tooltip-placement="left"
                                    type="button"
                                    onClick={() => {
                                        if (shouldDisable || requestingTransfer) return;
                                        onRequestingFundTransfer();
                                    }}
                                    disabled={shouldDisable || requestingTransfer}
                                    variant="blue"
                                    size="md"
                                    shape="rounded"
                                >
                                    {requestingTransfer ? <Loader /> : 'Request Fund Transfer'}
                                </ButtonNew>

                                <div
                                    id="tooltip-left"
                                    role="tooltip"
                                    style={{
                                        top: '50%',
                                        right: '100%',
                                        transform: 'translateY(-50%)',
                                    }}
                                    className={`absolute z-10 mr-3 w-[494px] px-4 py-2 transition-opacity duration-300 ${isVisible && shouldDisable ? 'opacity-100 visible' : 'opacity-0 invisible'
                                        } text-sm font-medium text-textPrimary border border-borderUnderline bg-grayBgNormal rounded-[4px] shadow-sm opacity-0`}
                                >
                                    <p className="text-sm">
                                        Fund Transfer can be requested only after the bounty expires on &nbsp;
                                        {formatIntDateAndThenTime(bountyDetails?.expirationTimestamp)} and when all
                                        submissions have been validated.
                                    </p>
                                    <div class="tooltip-arrow" data-popper-arrow></div>
                                </div>
                            </div>
                        </div>
                    )}

                {!isLoading && status?.toLowerCase() === 'validation requested' && bountyDetails?.raisedFunding && (
                    <div className="self-end">
                        <div className="relative">
                            <ButtonNew
                                onMouseEnter={handleMouseEnter}
                                onMouseLeave={handleMouseLeave}
                                data-tooltip-target="tooltip-left"
                                data-tooltip-placement="left"
                                type="button"
                                onClick={() => {
                                    if (
                                        status?.toLowerCase() === 'validation requested' &&
                                        bountyDetails?.raisedFunding
                                    )
                                        return;

                                    onRequestingFundTransfer();
                                }}
                                disabled={status?.toLowerCase() === 'validation requested' && bountyDetails?.raisedFunding}
                                variant="blue"
                                size="md"
                                shape="rounded"
                            >
                                Request Fund Transfer
                            </ButtonNew>

                            <div
                                id="tooltip-left"
                                role="tooltip"
                                style={{
                                    top: '50%',
                                    right: '100%',
                                    transform: 'translateY(-50%)',
                                }}
                                className={`absolute z-10 mr-3 w-[494px] px-4 py-2 transition-opacity duration-300 ${isVisible &&
                                    status?.toLowerCase() === 'validation requested' &&
                                    bountyDetails?.raisedFunding
                                    ? 'opacity-100 visible'
                                    : 'opacity-0 invisible'
                                    } text-sm font-medium text-textPrimary border border-borderUnderline bg-grayBgNormal rounded-[4px] shadow-sm opacity-0`}
                            >
                                <p className="text-sm">
                                    Fund transfer has been initiated and will be completed within 24 hours from the time
                                    of request.
                                </p>
                                <div class="tooltip-arrow" data-popper-arrow></div>
                            </div>
                        </div>
                    </div>
                )}


            </div>
            {
                ["Live and Published", "Live and Unpublished"]?.includes(status) &&
                <div className='flex items-center justify-end mt-[.375rem]'>
                    <p onClick={() => {
                        handleOpenModal('expire', bountyDetails);
                    }
                    } className='text-[#E92C2C] text-sm font-medium hover:underline cursor-pointer '>
                        {
                            bountyDetails?.validationType === "ALL_TOGETHER" ? "or forcefully expire bounty →" : "Forcefully expire bounty →"
                        }
                    </p>

                </div>

            }

            <Table className=" items-center gap-8 " cols="grid-cols-12">
                <Table.Header isBorder={false}>
                    <p className="text-sm col-span-3  font-semibold text-secondaryText "> Username </p>
                    <p className="text-sm col-span-4  font-semibold text-secondaryText "> Submission ID </p>
                    <p className="text-sm justify-self-center col-span-2  font-semibold text-secondaryText ">Score</p>
                    <p className="text-sm col-span-3  font-semibold text-secondaryText ">Impact Certificate</p>
                </Table.Header>
                {isLoading ? (
                    <div className="min-h-[20vh] flex justify-center items-center">
                        <Loader />
                    </div>
                ) : submissions.length ? (
                    (() => {
                        // Step 1: Group submissions by username
                        const userGroups = {};

                        submissions.forEach((submission) => {
                            const username = submission.submitterUsername;
                            if (!userGroups[username]) {
                                userGroups[username] = [];
                            }
                            userGroups[username].push(submission);
                        });

                        // Step 2: Sort submissions within each user group by score (descending)
                        Object.keys(userGroups).forEach(username => {
                            userGroups[username].sort((a, b) => {
                                const scoreA = a.accuracy >= 0 ? a.accuracy : -1;
                                const scoreB = b.accuracy >= 0 ? b.accuracy : -1;
                                return scoreB - scoreA; // Descending order
                            });
                        });

                        // Step 3: Calculate highest score for each user and sort users by highest score
                        const usersByHighestScore = Object.keys(userGroups).map(username => {
                            const userSubmissions = userGroups[username];
                            const highestScore = Math.max(...userSubmissions.map(s => s.accuracy >= 0 ? s.accuracy : -1));
                            return {
                                username,
                                highestScore,
                                submissions: userSubmissions
                            };
                        });

                        // Sort users by their highest score (descending)
                        usersByHighestScore.sort((a, b) => b.highestScore - a.highestScore);

                        // Step 4: Create final grouped submissions array
                        const groupedSubmissions = usersByHighestScore.map(user => user.submissions);

                        // Step 5: Create a flat array sorted by score for ranking calculation
                        const allSubmissionsSortedByScore = [...submissions].sort((a, b) => {
                            const scoreA = a.accuracy >= 0 ? a.accuracy : -1;
                            const scoreB = b.accuracy >= 0 ? b.accuracy : -1;
                            return scoreB - scoreA; // Descending order by score
                        });

                        return groupedSubmissions.map((group, groupIndex) => (
                            <div key={`group - ${groupIndex} `}>
                                {group.map((submission, submissionIndex) => {
                                    const isFirstInGroup = submissionIndex === 0;
                                    const isLastInGroup = submissionIndex === group.length - 1;
                                    const hasMultipleSubmissions = group.length > 1;
                                    const isFirstGroup = groupIndex === 0;
                                    const isLastGroup = groupIndex === groupedSubmissions.length - 1;

                                    // Calculate rank based on individual score position in all submissions
                                    const rankIndex = allSubmissionsSortedByScore.findIndex(s => s.submissionId === submission.submissionId);

                                    // Border logic
                                    let borderClasses = '';

                                    if (hasMultipleSubmissions) {
                                        // Dark borders for multiple submissions (box)
                                        if (isFirstInGroup) {
                                            borderClasses = 'border-t border-borderUnderline';
                                        } else {
                                            // Light border between entries within the same user group
                                            borderClasses = 'border-t border-borderUnderline';
                                        }
                                        if (isLastInGroup) {
                                            // Always use dark border for bottom of the box - use specific bottom border class
                                            borderClasses += ' border-b border-b-borderUnderline';
                                        }
                                    } else {
                                        // Light borders for single submissions
                                        const prevGroup = groupIndex > 0 ? groupedSubmissions[groupIndex - 1] : null;
                                        const nextGroup = groupIndex < groupedSubmissions.length - 1 ? groupedSubmissions[groupIndex + 1] : null;
                                        const prevGroupHasMultiple = prevGroup && prevGroup.length > 1;
                                        const nextGroupHasMultiple = nextGroup && nextGroup.length > 1;

                                        // Only add top border if previous group doesn't have multiple submissions (no box above)
                                        if (isFirstInGroup && !prevGroupHasMultiple) {
                                            borderClasses = 'border-t border-borderUnderline';
                                        }
                                        // Only add bottom border if next group doesn't have multiple submissions (no box below)
                                        if (isLastInGroup && !nextGroupHasMultiple) {
                                            borderClasses += ' border-b border-borderUnderline';
                                        }
                                    }

                                    // Remove top border if previous group had bottom border (avoid double borders)
                                    if (!isFirstGroup && isFirstInGroup) {
                                        const prevGroup = groupedSubmissions[groupIndex - 1];
                                        const prevGroupHasMultiple = prevGroup.length > 1;

                                        if (hasMultipleSubmissions && prevGroupHasMultiple) {
                                            // Both groups have multiple submissions - remove top border to avoid double dark border
                                            borderClasses = borderClasses.replace('border-t border-borderUnderline', '');
                                        } else if (!hasMultipleSubmissions && !prevGroupHasMultiple) {
                                            // Both groups have single submissions - remove top border to avoid double light border
                                            borderClasses = borderClasses.replace('border-t border-[#e8e8e8]', '');
                                        }
                                    }

                                    return (
                                        <Table.Row
                                            key={submission.submissionId}
                                            isBorder={false}
                                            rowClassName={borderClasses}
                                        >
                                            <div className="col-span-3 flex items-center cursor-pointer justify-self-start">
                                                {isFirstInGroup ? (
                                                    <div className="flex items-center gap-1">
                                                        <AvatarImage w="w-6" h="h-6" url={submission?.submitterProfileImage} />
                                                        <p className="text-textPrimary">{submission?.submitterUsername}</p>
                                                        {getSubmissionRank(submission.submissionId)}
                                                    </div>
                                                ) : (
                                                    <div className="flex items-center gap-1">
                                                        <p className="text-textSecondary text-sm">same as above</p>
                                                        {getSubmissionRank(submission.submissionId)}
                                                    </div>
                                                )}
                                            </div>
                                            <p
                                                onClick={() => {
                                                    if (fromPage === "individualbounty") {
                                                        navigate(`${submission.submissionId}?from = ${fromPage} `)
                                                    }
                                                    else if (fromPage === "validation") {
                                                        navigate(`${submission.submissionId}?from = ${fromPage}& fromTab=${fromTab} `)
                                                    }
                                                    else {
                                                        navigate(submission.submissionId)
                                                    }
                                                }}
                                                className="col-span-4 text-textBrandBlue flex items-center cursor-pointer uppercase justify-self-start font-medium"
                                            >
                                                <span className="truncate">{submission.submissionId}</span>
                                            </p>
                                            <p className="justify-self-center col-span-2 text-textPrimary">
                                                {submission?.accuracy >= 0 ? (Number(submission.accuracy) * 100).toFixed(2) : '-'}
                                            </p>
                                            <p className="col-span-3">
                                                {submission?.impactCertificateIssued || submission?.issueImpactCertificate ? (
                                                    <IssuedIcon />
                                                ) : (
                                                    <NotIssuedIcon />
                                                )}
                                            </p>
                                        </Table.Row>
                                    );
                                })}
                            </div>
                        ));
                    })()
                ) : (
                    <NoDataAvailable />
                )}
                {totalEntries > 10 && (
                    <div className="w-[100%] mx-auto">
                        <Pagination
                            className="pt-6 pb-[.65rem]"
                            hoverColor="hover:text-textPrimary"
                            currentColor="bg-neutral50D"
                            textActive="text-textPrimary"
                            currentPage={currentPage}
                            totalPages={Math.ceil(totalEntries / entriesPerPage)}
                            entriesPerPage={entriesPerPage}
                            totalEntries={totalEntries}
                            entriesHandler={entriesHandler}
                            onPageChange={setCurrentPage}
                            border="border-borderUnderline"
                            hoverBorder="hover:border-borderUnderline"
                        />
                    </div>
                )}
                <div className="flex items-center justify-end mt-6">
                    <div className="flex items-center gap-3 ">
                        <p className="text-sm font-bold">Impact Certificate</p>
                        <Legend shield={<NotIssuedIcon />} text={'Not Issued'} />
                        <Legend shield={<IssuedIcon />} text={'Issued'} />
                    </div>
                </div>
            </Table>
            {modalAction === 'expire' && (
                <ForcefullyExpireBountyModal
                    onForcefullyExpire={handleConfirmAction}
                    bountyName={selectedBounty.title}
                    bountyId={selectedBounty._id}
                    close={handleCloseModal}
                />
            )}
        </div>
    );
}

export default ValidationBountySubmission;

// submissions.length === scoresCount && status?.toLowerCase() === 'unvalidated' &&
// {submission?.accuracy ? (
//     submission?.accuracy * 100 >= 40 ? (
//         <span>{index + 1 <= 3 && rank[index + 1]}</span>
//     ) : null
// ) : null}

// const payload = {
//     title: overviewrow.title,
//     projectTitle: overviewrow.projectTitle,
//     startDate: overviewrow.startTimestamp,
//     endDate: overviewrow.expirationTimestamp,
//     totalSubmissions: unvalidatedBounties.length,
//     status: overviewrow.status,
//     hasImpactCertificate: overviewrow?.hasImpactCertificate,
//     passThreshold: overviewrow?.passThreshold,
//     validationType: overviewrow?.validationType,
//     raisedFunding: overviewrow?.raisedFunding,
// };
// handleBountyDetails(payload);
